import { useMutation, useQueryClient } from "react-query";
import { mutatePutFn } from "../../services/networking.service";
import ENDPOINTS from "../../services/endPoints";

export interface UpdateCapacityAlertSettingsParams {
  scope: "global" | "host";
  key_host_id?: string;
  low_slot_threshold: number;
}

export const useUpdateCapacityAlertSettings = () => {
  const queryClient = useQueryClient();
  return useMutation<any, any, any>(
    (data) => mutatePutFn(ENDPOINTS.CAPACITY_ALERT_SETTINGS, data),
    {
      onSuccess: async () => {
        queryClient.invalidateQueries([ENDPOINTS.CAPACITY_ALERT_SETTINGS]);
      },
    }
  );
};
